const localizers = {
  'loading.msg': () => `正在載入…`,
  'SASServer.genericError.msg': () => `無法連到伺服器。`,
  'SASReport.genericError.msg': () => `無法載入所選的報表。`,
  'SASReportImage.genericError.msg': () => `無法載入報表影像。`,
  'SASReportImage.imageNotSupported.msg': () => `此報表內容類型不支援影像。`,
}
export default localizers;
